import * as React from "react";
import { Dialog, DialogSurface, DialogBody, tokens, Toolbar, Button } from "@fluentui/react-components";
import { SendRegular } from "@fluentui/react-icons";
import RichTextEditor from "../../../shared/components/RichTextEditor";

import Files from "../../files/components/Files";
import { useAuth } from "../../../provider/authProvider";

import { useCreateTicketUpdate, useUpdateTicketUpdate } from "../hooks/useTicketUpdateMutations";
import { t } from "i18next";

const TicketNoteEditor = ({ ticketUpdate, isOpen, onOpenChange, value, selectedLanguage, onLanguageChange }) => {
  const attachmentsRef = React.useRef(null);
  const editorRef = React.useRef(null);
  const { user: currentUser } = useAuth();

  const { mutateAsync: createTicketUpdateMutate } = useCreateTicketUpdate(
    ["TicketUpdates", ticketUpdate?.ticket_id],
    async (data) => {
      // If success
    },
    null,
    true,
  );
  const { mutateAsync: updateTicketUpdateMutate } = useUpdateTicketUpdate(
    ["TicketUpdates", ticketUpdate?.ticket_id],
    async (data) => {
      // If success
    },
    null,
    true,
  );

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogSurface
        id="edit-ticket-update-dialog"
        style={{
          border: `2px solid ${tokens.colorNeutralStroke1}`,
          borderRadius: "4px",
          minWidth: "600px",
          maxWidth: "50%",
          padding: "0",
          margin: "auto",
          boxShadow: "0 8px 16px rgba(0, 0, 0, 0.15)",
        }}
      >
        <DialogBody
          id="edit-ticket-update-dialog-body"
          style={{ width: "100%", display: "flex", flexDirection: "column", padding: "20px", margin: "0" }}
        >
          <div
            style={{
              border: `1px solid ${tokens.colorNeutralStroke1}`,
              borderRadius: "4px",
              flex: 1,
              width: "100%",
              display: "flex",
              padding: "0",
              margin: "0",
              //boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)",
            }}
          >
            <RichTextEditor
              ref={editorRef}
              style={{ minHeight: "600px", width: "100%", margin: "0", padding: "0" }}
              value={value}
              selectedLanguage={selectedLanguage}
              onLanguageChange={onLanguageChange}
              onChange={() => {}}
              placeholder={t("generic.editUpdate", { defaultValue: "Edit update..." })}
            />
          </div>
          <div
            id="attachments-section"
            style={{ display: "flex", alignItems: "flex-start", marginTop: "10px", width: "100%" }}
          >
            <Files
              ref={attachmentsRef}
              style={{ flex: 1, minWidth: 0 }}
              entity_type="ticket_update"
              entity_id={ticketUpdate?.id}
              editable
            />
            <Toolbar style={{ flexShrink: 0, marginLeft: "auto" }}>
              <Button
                appearance="secondary"
                onClick={() => {
                  attachmentsRef.current?.clearPending();
                  editorRef.current?.clear();
                  onOpenChange?.(null, { open: false });
                }}
                style={{ marginRight: 8 }}
              >
                Cancel
              </Button>
              <Button
                appearance="primary"
                icon={<SendRegular />}
                onClick={async () => {
                  const pendingAttachments = attachmentsRef.current?.getPendingAttachments() || [];
                  const pendingDeletions = attachmentsRef.current?.getPendingDeletions() || [];
                  await (ticketUpdate?.public_id ? updateTicketUpdateMutate : createTicketUpdateMutate)({
                    publicId: ticketUpdate?.public_id,
                    ticket_id: ticketUpdate?.ticket_id,
                    author_id: currentUser?.id,
                    content: editorRef.current?.getContent() || "",
                    language: editorRef.current?.getLanguage() || null,
                    attachments: pendingAttachments,
                    deletions: pendingDeletions,
                  });
                  attachmentsRef.current?.clearPending();
                  editorRef.current?.clear();
                  onOpenChange?.(null, { open: false });
                }}
              />
            </Toolbar>
          </div>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default TicketNoteEditor;
